import React, { Component } from "react";
import __ from "lodash";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import { CONFIG, URL_AKM } from "../../../../config";
import akmApi from "../../../../apis/akmApi";
import LoaderModal from "../../../modal/LoaderModal";
import DropdownKelas from "../masterDropDown/DropdownKelas";
import DropdownMapel from "../masterDropDown/DropdownMapel";
import DropdownIndikator from "../masterDropDown/DropdownIndikator";
import DropdownUploadHistory from "../masterDropDown/DropdownUploadHistory";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Row, Col, Alert } from "react-bootstrap";
import { appendScript } from "../utils/appendScript";
import "./soalStyle.css";
import SoalMc from "./SoalMc";
import SoalMcc from "./SoalMcc";
import SoalBenarSalah from "./SoalBenarSalah";
import SoalEssay from "./SoalEssay";
import SoalDragDrop from "./SoalDragDrop";
import DropdownUploadHistoryAsync from "./DropdownUploadHistoryAsync";

class AddSoal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listKelas: [],
      listMapel: [],
      listTipeSoal: [],
      listIndikator: [],
      uploadHis: [],
      soal: this.props.location.state.soal,
      filterSoalSearch: this.props.location.state.params,
      isFetching: false,
      alertShow: false,
      resMessage: "",
      action: "add",
      soalDetailAkm: [],
    };
  }

  async componentDidMount() {
    appendScript("/tinymceinit.js");
    this.setState({ isFetching: true });
    await this.props.cekCookies();    
    if (!__.isEmpty(this.props.account)) {
      this.fetchKelas();
      this.fetchTipeSoal();
      this.fetchUploadHis();
      if (this.state.filterSoalSearch.idKelas !== null) {
        this.fetchMapel(this.state.filterSoalSearch.idKelas);
      }
      if (this.state.filterSoalSearch.idMataPelajaran !== null) {
        this.fetchIndikator(this.state.filterSoalSearch.idKelas, this.state.filterSoalSearch.idMataPelajaran);
      }
      if (!__.isEmpty(this.state.soal)) {
        this.setState({ action: "edit" });
      }

      this.setState({
        soal: {
          ...this.state.soal,
          idKelas: this.props.location.state.params.idKelas,
          idMataPelajaran: this.props.location.state.params.idMataPelajaran,
          tipeSoal: this.props.location.state.params.tipeSoal,
          idUploadHistory: this.props.location.state.params.idUploadHistory,
        },
      });
    }

    this.setState({ isFetching: false });
  }

  fetchKelas = async () => {
    this.setState({ showAlert: false });
    const response = await akmApi.get(URL_AKM.KELAS_ALL).catch(function (error) {
      this.setState({ showAlert: true, resMessage: error });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listKelas: response.data.data,
        });
      } else {
        this.setState({
          listKelas: [],
          showAlert: true,
          resMessage: "Kelas " + response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchMapel = async (idKelas) => {
    this.setState({ showAlert: false });
    const response = await akmApi.get(URL_AKM.MAPEL_GET_BY_IDKELAS + idKelas).catch(function (error) {
      this.setState({ showAlert: true, resMessage: error });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listMapel: response.data.data,
        });
      } else {
        this.setState({
          listMapel: [],
          showAlert: true,
          resMessage: "Mapel " + response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchTipeSoal = async () => {
    const response = await akmApi.get(URL_AKM.GET_TIPE_SOAL).catch(function (error) {
      this.setState({ showAlert: true, resMessage: error });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listTipeSoal: response.data.data,
        });
      } else {
        this.setState({
          listTipeSoal: [],
          showAlert: true,
          resMessage: response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchIndikator = async (idKelas, idMapel) => {
    this.setState({ showAlert: false });
    const response = await akmApi
      .get(URL_AKM.GET_INDIKATOR, {
        params: { idKelas: idKelas, idMataPelajaran: idMapel },
      })
      .catch(function (error) {
        this.setState({ showAlert: true, resMessage: error });
      });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listIndikator: response.data.data,
        });
      } else {
        this.setState({
          listIndikator: [],
          showAlert: true,
          resMessage: "Indikator " + response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  async fetchUploadHis() {
    const result = await akmApi.post(URL_AKM.POST_UPLOAD_HISTORY_ID, { idAdmin: this.props.account.idAdmin }).catch(function (error) {
      console.log(error);
    });

    if (result) {
      let uploadHistory = [];
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        uploadHistory = result.data.data;
      }
      this.setState({ uploadHis: uploadHistory });
    }
  }

  handleChangeKelas = (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ soal: { ...this.state.soal, idKelas: null } });
    } else {
      this.setState({ soal: { ...this.state.soal, idKelas: value } });
      this.fetchMapel(value);
    }
  };
  handleChangeMapel = (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ soal: { ...this.state.soal, idMataPelajaran: null }, listIndikator: [] });
    } else {
      this.setState({ soal: { ...this.state.soal, idMataPelajaran: value } });
      this.fetchIndikator(this.state.soal.idKelas, value);
    }
  };
  handleChangeBobot = (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ soal: { ...this.state.soal, mudahSulit: null } });
    } else {
      this.setState({ soal: { ...this.state.soal, mudahSulit: value } });
    }
  };
  handleChangeIndikator = (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ soal: { ...this.state.soal, idIndikator: null } });
    } else {
      this.setState({ soal: { ...this.state.soal, idIndikator: value } });
    }
  };
  handleChangeUpHis = (id) => {
    // const { value } = event.target;
    if (id === "") {
      this.setState({ soal: { ...this.state.soal, idUploadHistory: null } });
    } else {
      this.setState({ soal: { ...this.state.soal, idUploadHistory: id } });
    }
  };

  handleChangeKunci = (value) => {
    this.setState({ soal: { ...this.state.soal, kunciJawaban: value.trim() } });
  };
  addSoalDetailAkm = (value) => {
    this.setState({ soalDetailAkm: value });
  };

  handleSubmit = async () => {
    const { filterSoalSearch } = this.state;
    if (this.state.soal.mudahSulit === undefined) {
      this.setState({ alertShow: true, resMessage: "Bobot Soal harus di isi... !!" });
      return false;
    }
    if (this.state.soal.tipeSoal === "MCC") {
      const check = this.state.soal.kunciJawaban;
      if (__.isUndefined(check)) {
        alert("Kunci Jawaban harus diisi...");
        return false;
      }
      const str = check.split(",");
      if (str.length < 3) {
        alert("Kunci Jawaban harus diisi minimal 3...");
        return false;
      }
    }
    if (__.isEmpty(window.tinyMCE.get("pertanyaan").getContent())) {
      this.setState({ alertShow: true, resMessage: "Field pertanyaan harus di isi... !!" });
      window.tinyMCE.get("pertanyaan").focus();
      return false;
    }

    // console.log('soal detail akm e', this.state.soalDetailAkm)
    // this.submitDetailSoal(1);

    if (window.confirm("Konfirmasi Simpan ?")) {
      this.setState({ isFetching: true });
      let dataSend = { ...this.state.soal, pertanyaan: window.tinyMCE.get("pertanyaan").getContent(), isianJawaban: window.tinyMCE.get("pembahasan").getContent() };
      if (filterSoalSearch.tipeSoal === "MULTIPLE" || filterSoalSearch.tipeSoal === "MCC" || filterSoalSearch.tipeSoal === "DROPDOWN") {
        dataSend = {
          ...dataSend,
          jawab1: window.tinyMCE.get("jawab1").getContent() === "" ? null : window.tinyMCE.get("jawab1").getContent(),
          jawab2: window.tinyMCE.get("jawab2").getContent() === "" ? null : window.tinyMCE.get("jawab2").getContent(),
          jawab3: window.tinyMCE.get("jawab3").getContent() === "" ? null : window.tinyMCE.get("jawab3").getContent(),
          jawab4: window.tinyMCE.get("jawab4").getContent() === "" ? null : window.tinyMCE.get("jawab4").getContent(),
          jawab5: window.tinyMCE.get("jawab5").getContent() === "" ? null : window.tinyMCE.get("jawab5").getContent(),
        };
      }

      const res = await akmApi.post(URL_AKM.BANK_SOAL_POST, dataSend).catch(function (error) {
        console.log(error);
      });
      if (res) {
        if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          if (filterSoalSearch.tipeSoal === "BNS" || filterSoalSearch.tipeSoal === "DRAG") {
            this.submitDetailSoal(res.data.data.idBankSoal);
          } else {
            this.props.history.push({
              pathname: "/soal_akm",
              state: { params: this.state.filterSoalSearch },
            });
          }
        } else {
          this.setState({
            isFetching: false,
            alertShow: true,
            resMessage: res.data.errorSchema.errorMessage,
          });
        }
      }
    }
  };

  submitDetailSoal = async (idBankSoal) => {
    this.setState({ isFetching: true });
    console.log(this.state);
    let arrays = [...this.state.soalDetailAkm];
    if (this.state.soal.tipeSoal === "DRAG") {
      arrays.map((obj) => {
        obj.idBankSoal = idBankSoal;
      });
    } else {
      arrays.map((obj) => {
        obj.idBankSoal = idBankSoal;
        obj.id = null;
      });
    }

    const response = await akmApi.post(URL_AKM.POST_SOAL_DETAIL_AKM, arrays).catch(function (error) {
      console.log(error);
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.props.history.push({
          pathname: "/soal_akm",
          state: { params: this.state.filterSoalSearch },
        });
      } else {
        alert("Error..." + response.data.errorSchema.errorMessage);
      }
    }
  };

  renderEditor() {
    const { filterSoalSearch } = this.state;
    if (filterSoalSearch.tipeSoal === "MULTIPLE" || filterSoalSearch.tipeSoal === "DROPDOWN") {
      return <SoalMc soal={this.state.soal} handleChange={this.handleChangeKunci} />;
    }
    if (filterSoalSearch.tipeSoal === "MCC") {
      return <SoalMcc soal={this.state.soal} handleChange={this.handleChangeKunci} />;
    }
    if (filterSoalSearch.tipeSoal === "ESSAY" || filterSoalSearch.tipeSoal === "ISIAN") {
      return <SoalEssay soal={this.state.soal} handleChange={this.handleChangeKunci} />;
    }
    if (filterSoalSearch.tipeSoal === "BNS") {
      return <SoalBenarSalah soal={this.state.soal} addSoalDetailAkm={this.addSoalDetailAkm} />;
    }
    if (filterSoalSearch.tipeSoal === "DRAG") {
      return <SoalDragDrop soal={this.state.soal} addSoalDetailAkm={this.addSoalDetailAkm} />;
    }
  }

  render() {
    const { soal, filterSoalSearch, action } = this.state;
    let title = "";
    if (action === "add") {
      title = "Add";
    } else if (action === "edit") {
      title = "Edit";
    }
    return (
      <div className="containerFluid" style={{ paddingTop: "10px", paddingBottom: "50px" }}>
        <LoaderModal isFetching={this.state.isFetching} />

        <div className="text-center">
          <h5>
            {title} Soal - {filterSoalSearch.keterangan}
          </h5>
        </div>
        <Col sm={12}>
          {this.loadAlert()}
          <Row>
            <Col>
              <div className="form-group">
                <select className="form-control" name="kelas" id="kelas" value={soal.idKelas || ""} onChange={this.handleChangeKelas.bind(this)}>
                  <option value="" disabled>
                    Pilih Kelas...
                  </option>
                  <DropdownKelas kelas={this.state.listKelas} />
                </select>
              </div>
            </Col>
            <Col>
              <div className="form-group">
                <select className="form-control" name="mapel" id="mapel" value={soal.idMataPelajaran || ""} onChange={this.handleChangeMapel.bind(this)}>
                  <option value="" disabled>
                    Pilih Mapel...
                  </option>
                  <DropdownMapel mapel={this.state.listMapel} />
                </select>
              </div>
            </Col>

            <Col>
              <div className="form-group">
                <select className="form-control" name="bobot" id="bobot" value={soal.mudahSulit || ""} onChange={this.handleChangeBobot}>
                  <option value="" disabled>
                    Pilih Bobot Soal...
                  </option>
                  <option value="5">Sangat Mudah</option>
                  <option value="1">Mudah</option>
                  <option value="2">Sedang</option>
                  <option value="3">Sulit</option>
                  <option value="4">Sangat Sulit</option>
                </select>
              </div>
            </Col>
            <Col>
              <div className="form-group">
                <select className="form-control" name="indikator" id="indikator" value={soal.idIndikator || ""} onChange={this.handleChangeIndikator}>
                  <option value="" disabled>
                    Pilih Indikator...
                  </option>
                  <DropdownIndikator indi={this.state.listIndikator} />
                </select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              {/* <div className="form-group">
                <select className="form-control" name="uphis" id="uphis" value={soal.idUploadHistory || ""} onChange={this.handleChangeUpHis}>
                  <option value="" disabled>
                    Pilih Upload History...
                  </option>
                  <DropdownUploadHistory uploadHis={this.state.uploadHis} />
                  
                </select>
              </div> */}
              <DropdownUploadHistoryAsync idAdmin={this.props.account.idAdmin} handleChangeUpHis={(idUploadHistory) => this.handleChangeUpHis(idUploadHistory)} />
            </Col>
          </Row>
        </Col>

        {this.renderEditor()}

        {/* {filterSoalSearch.tipeSoal !== 'DRAG' &&  */}
        <div className="bottom-header-fixed">
          <Row>
            <Col sm={6}>
              <button className="btn btn-danger pull-left" onClick={() => this.handleBack()}>
                <ArrowBackIosIcon /> Back
              </button>
            </Col>
            <Col sm={6}>
              <button className="btn btn-primary pull-right" onClick={this.handleSubmit}>
                <SaveIcon /> Save
              </button>
            </Col>
          </Row>
        </div>
        {/* }          */}
      </div>
    );
  }

  handleBack() {
    
    if (window.confirm("Are You Sure... ??")) {
      
      this.props.history.push({
        pathname: this.props.location.state.fromUrl,
        state: { params: this.state.filterSoalSearch },
      });
    }
  }

  loadAlert = () => {
    const { alertShow } = this.state;

    if (alertShow) {
      return (
        <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
          <strong>{this.state.resMessage}</strong>
        </Alert>
      );
    }
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(AddSoal);
